export default __webpack_public_path__ + "static/media/distance-measure.228975c8.svg";